import { get, keyBy, isEmpty } from 'lodash'
import {
  FETCH_VENUES,
  SELECT_VENUE,
  FETCH_VENUES_REQUESTED,
  FETCH_VENUES_FAILED
} from './actionTypes'
import { SIGN_OUT } from 'store/Auth/actionTypes'

const initialState = {
  byId: {},
  selectedId: '',
  isLoading: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_VENUES: {
      const venues = payload.venues.map(({ venueName, venueUuid }) => ({
        label: venueName,
        value: venueUuid,
      }))

      return {
        ...state,
        byId: keyBy(venues, 'value'),
        selectedId: isEmpty(state.selectedId) ? get(venues, [0, 'value']) : state.selectedId,
        isLoading: false,
      }
    }

    case FETCH_VENUES_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case FETCH_VENUES_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case SELECT_VENUE: {
      return {
        ...state,
        selectedId: payload,
      }
    }

    case SIGN_OUT: {
      return {
        ...state,
        selectedId: '',
      }
    }

    default:
      return state
  }
}
